export type Reference = {
  title: string;
  client: string;
  location: string;
  period: string;
  category: string;
  summary: string;
  image: string;
  alt: string;
};

export const references: Reference[] = [
  {
    title: 'Projet de renouvellement urbain du quartier des Hauts-de-Loire',
    client: 'Communauté d’agglomération',
    location: 'Centre-Val de Loire',
    period: '2019 – 2026',
    category: 'Renouvellement urbain',
    summary:
      'Pilotage de la convention NPNRU : 640 logements réhabilités, 210 démolitions-reconstructions et un nouveau parc central conçu avec les habitants.',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/2a5948ce-05a8-44c6-8af0-52c5ccfe87cb.jpg',
    alt: 'Résidences réhabilitées face à un parc paysager',
  },
  {
    title: 'OPAH-RU du centre historique',
    client: 'Ville moyenne – Action Cœur de Ville',
    location: 'Nouvelle-Aquitaine',
    period: '2021 – 2025',
    category: 'Habitat privé',
    summary: 'Étude pré-opérationnelle et suivi-animation, 380 logements accompagnés.',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/f1449893-8098-491f-86ec-686778c29b3f.jpg',
    alt: 'Rue de centre ancien aux façades en pierre restaurées',
  },
  {
    title: 'Programme local de l’habitat 2024 – 2029',
    client: 'Communauté de communes',
    location: 'Auvergne-Rhône-Alpes',
    period: '2023 – 2024',
    category: 'Politique de l’habitat',
    summary: 'Élaboration concertée avec 42 communes et l’ensemble des bailleurs du territoire.',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/6014bea7-66b6-45fe-a42d-f0d4d6cdac29.jpg',
    alt: 'Atelier de concertation autour d’une carte du territoire',
  },
];
